/**
 * i18n bootstrap. Uses react-i18next with in-memory JSON resource files.
 *
 * Scope for MVP: the strings employees see (dashboard header, greeting,
 * shift card labels, complete/waiting-for-manager messages). Owner/manager
 * screens stay in English for now — full-app translation is a larger effort
 * tracked separately. Untranslated strings fall back to the English default
 * passed to `t()`, so nothing "disappears" if a key is missing in hi/mr.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import mr from './locales/mr.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    mr: { translation: mr },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React already escapes
  returnEmptyString: false,
});

export default i18n;
